<div
  *ngFor="let inquiry of similarInquiries; trackBy: trackByInquiry"
  class="inquiry-teaser inquiry-employee-container p-0"
>
  <div class="inquiry-left-content">
    <div class="py-3 d-flex justify-content-between flex-column">
      <div>
        <div class="text-dark-green fw-medium">{{ inquiry.data.mainQualification.name }}</div>
        <div>
          <span>{{ inquiry.data.dateFrom | baseFormatDate }}</span> -
          <span>{{ inquiry.data.dateTo | baseFormatDate }}</span>
        </div>
        <ng-container *ngIf="inquiry.data.qualifications?.length">
          <div class="text-dark-gray">
            {{ inquiry.data.qualifications[0].name }}<br />
            <span
              *ngIf="inquiry.data.qualifications.length > 1"
              [ngbTooltip]="tooltipWithQualificationsList"
            >
              + {{ inquiry.data.qualifications.length - 1 }} {{ 'additional' | translate }}
            </span>
          </div>
        </ng-container>
        <ng-template #tooltipWithQualificationsList>
          <ul class="mb-0 list-unstyled text-start">
            <li *ngFor="let qualification of inquiry.data.qualifications | slice: 1">
              {{ qualification.name }}
            </li>
          </ul>
        </ng-template>
      </div>

      <div class="fw-bold">
        {{ 'inquiry.by' | translate }} {{ inquiry.data.createdBy.firstName }} {{ inquiry.data.createdBy.lastName
        }}<br />
        {{ 'inquiry.at' | translate }} {{ inquiry.data.createdAt | baseFormatDate: true }}
      </div>
    </div>
    <div class="d-flex flex-column">
      <div
        *ngFor="let shiftTime of shiftTimesWithFlex; let i = index"
        class="inquiry-shift-time d-flex justify-content-end align-items-center"
        [ngClass]="{ 'inquiry-shift-time-flex': shiftTime.type === inquiryShiftTypes.FLEX }"
        [ngbTooltip]="'shiftTimes.' + shiftTime.type | translate"
      >
        <span
          *ngIf="shiftTime.type === inquiryShiftTypes.FLEX"
          class="text-uppercase"
          [class]="inquiry.availableShifts[shiftTime.type] ? 'text-primary' : 'text-light-gray'"
        >
          {{ shiftTime.type | translate }}
        </span>
        <i
          *ngIf="shiftTime.type !== inquiryShiftTypes.FLEX"
          class="fa-fw fa-regular {{ baseShiftIconsEnum[shiftTime.type] }}"
          [ngClass]="{
            'text-primary': inquiry.availableShifts[shiftTime.type],
            'text-light-gray': !inquiry.availableShifts[shiftTime.type]
          }"
        ></i>
      </div>
    </div>
  </div>
  <div class="inquiry-right-content">
    <base-customer-similar-inquiries-dates
      class="d-flex w-100"
      [similarInquiriesDays]="inquiry.dates"
    ></base-customer-similar-inquiries-dates>
  </div>
</div>

<base-empty-list-row
  *ngIf="similarInquiries.length === 0"
  [backgroundSecondary]="true"
  [hideBackgroundImage]="true"
  message="inquiry.emptySimilarInquiriesList"
></base-empty-list-row>
